import React from 'react';
export const PrivacyPolicy = () => {
  return <div className="pt-20" data-id="element-4622" data-mp="3t6sxch1samz1">
      <section className="py-16 bg-secondary/5" data-id="element-4623" data-mp="va605aps4odf">
        <div className="container mx-auto px-4" data-id="element-4624" data-mp="v9eht1l70n53">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4625" data-mp="qb37kpqzkamc">
            Privacy Policy
          </h1>
          <p className="text-center text-secondary" data-id="element-4626" data-mp="ma9i3rxwanrc">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-4627" data-mp="1iyp8trcqr361">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-4628" data-mp="1iyyy1cpyp6ao">
          <div className="prose prose-lg max-w-none" data-id="element-4629" data-mp="1e0dzdhqcyuoc">
            <p data-id="element-4630" data-mp="1e3065f5fd65i">
              The Networking Salon ("we," "our," or "us") values your trust.
              This Privacy Policy explains how we collect, use, and protect your
              information when you engage with our website, events, and
              community.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4631" data-mp="21scob4iqcojy">
              1. Information We Collect
            </h2>
            <p data-id="element-4632" data-mp="1wxowavoipc0m">When you interact with The Networking Salon, we may collect:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4633" data-mp="51sxq7phdjns">
              <li data-id="element-4634" data-mp="a0dozhmr8t03">
                <strong data-id="element-4635" data-mp="9ysvzwg39i4c">Personal Information:</strong> Name, email, phone
                number, company, role/title, and other details you share when
                registering for events, subscribing to updates, or filling out
                forms.
              </li>
              <li data-id="element-4636" data-mp="3ife7bjw70nam">
                <strong data-id="element-4637" data-mp="3iew0xuftgsoz">Community Information:</strong> If you join our network,
                we may collect details you provide about your professional
                background, interests, and connections.
              </li>
              <li data-id="element-4638" data-mp="38jklf9wl3hg6">
                <strong data-id="element-4639" data-mp="38k42koeeu1t5">Website Data:</strong> IP address, browser type, pages
                visited, and time spent on our site.
              </li>
              <li data-id="element-4640" data-mp="16rfvu52k4w8m">
                <strong data-id="element-4641" data-mp="16qwjd3vof01z">Cookies:</strong> Small files that help us improve your
                experience and track engagement.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4642" data-mp="1a8kgndzh2ohw">
              2. How We Use Your Information
            </h2>
            <p data-id="element-4643" data-mp="158fzdlqqppqm">We use your information to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4644" data-mp="10a4p59wj9d7v">
              <li data-id="element-4645" data-mp="10awa7qsi7sjw">Register you for events and send confirmations/updates.</li>
              <li data-id="element-4646" data-mp="w9b2ejutu4gk">
                Share relevant communications such as newsletters, networking
                opportunities, or event invitations.
              </li>
              <li data-id="element-4647" data-mp="1nzp83ssosah5">
                Improve the quality of our website, community, and events.
              </li>
              <li data-id="element-4648" data-mp="1j8qoaj8hou95">
                Build stronger connections between members of our network.
              </li>
              <li data-id="element-4649" data-mp="1f86v1qr1easa">Ensure compliance with legal and security requirements.</li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4650" data-mp="2bpt9dtiejy4z">
              3. Sharing Your Information
            </h2>
            <p data-id="element-4651" data-mp="26xiamtzeeie0">
              We respect your privacy. Your information is never sold. We may
              only share your information with:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4652" data-mp="3uked2hqmvro4">
              <li data-id="element-4653" data-mp="3ukxulxcdge1m">
                <strong data-id="element-4654" data-mp="3umie8rx5eckp">Event & Service Partners:</strong> Trusted providers
                (e.g., venues, ticketing, email platforms) necessary to deliver
                our services.
              </li>
              <li data-id="element-4655" data-mp="7dlpwxf121q4">
                <strong data-id="element-4656" data-mp="cet0t5cgvh10">Community Connections:</strong> With your consent, we
                may share limited professional information to foster
                introductions within our network.
              </li>
              <li data-id="element-4657" data-mp="m42qyfnr2pmh">
                <strong data-id="element-4658" data-mp="m5nma7hw2cle">Legal Obligations:</strong> When required by law or to
                protect our rights and community.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4659" data-mp="v5aqf1205wi5">
              4. Cookies & Tracking
            </h2>
            <p data-id="element-4660" data-mp="104400ie653d1">We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4661" data-mp="1055fr064qe13">
              <li data-id="element-4662" data-mp="mhdef4m0a1u3">Remember your preferences.</li>
              <li data-id="element-4663" data-mp="mg2a93ones2g">Understand how people use our site.</li>
              <li data-id="element-4664" data-mp="hj3i2qojov6w">Improve our content and event promotion.</li>
            </ul>
            <p data-id="element-4665" data-mp="w7ggrvf0os53">You can manage cookies through your browser settings.</p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4666" data-mp="w6ojmg5rumcp">5. Data Retention</h2>
            <p data-id="element-4667" data-mp="r9oce1x6rdk0">
              We keep your information only as long as needed to provide
              services, manage community relationships, or comply with legal
              obligations.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4668" data-mp="3uqn48y6vc691">6. Your Rights</h2>
            <p data-id="element-4669" data-mp="di02m5aet167">Depending on your location, you may have rights such as:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4670" data-mp="8i5fmctr8vqf">
              <li data-id="element-4671" data-mp="8gkj4hnvr2px">Accessing or updating your information.</li>
              <li data-id="element-4672" data-mp="1ovcb4th467yp">Requesting deletion of your data.</li>
              <li data-id="element-4673" data-mp="1oxyjuwfqqtii">Opting out of marketing communications at any time.</li>
              <li data-id="element-4674" data-mp="1jwizz7paut1p">Restricting certain uses of your personal information.</li>
            </ul>
            <p data-id="element-4675" data-mp="1reywrjc6180p">
              To exercise these rights, email us at:
              thenetworkingsalon@gmail.com
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4676" data-mp="1wda67syjtgie">7. Security</h2>
            <p data-id="element-4677" data-mp="1ihg7g2rho7j0">
              We use reasonable safeguards to protect your information. However,
              no online transmission is completely secure, so we encourage you
              to take care when sharing information.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4678" data-mp="2f5uwd2mv57ii">
              8. Third-Party Links
            </h2>
            <p data-id="element-4679" data-mp="21f99z3y7affv">
              The Networking Salon may link to external sites (e.g., partners,
              event platforms). We are not responsible for their privacy
              practices.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4680" data-mp="2t5nh8hbpktik">9. Policy Updates</h2>
            <p data-id="element-4681" data-mp="2xwdo5yzs94fd">
              We may update this Privacy Policy occasionally. Updates will be
              posted on this page with the latest revision date.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4682" data-mp="37qi2fnp72ctu">10. Contact Us</h2>
            <p data-id="element-4683" data-mp="33rir9lcvdjty">
              If you have questions about this Privacy Policy or how we handle
              your information, please reach out:
            </p>
            <p data-id="element-4684" data-mp="2ttcufi5x73vy">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-4685" data-mp="2tsl86xy7qiic">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};